// components/ClickToBuy.jsx
import React, { useContext } from "react";
// import { useNavigate } from "react-router-dom";
import styles from "./ClickToBuy.module.scss";
import MainButton from "../MainButton/MainButton.jsx";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";
import { pay } from "../../payments.js";

const ClickToBuy = () => {
  // const navigate = useNavigate();
  const { interfaceText } = useContext(LanguageContext);

  const handleBuy = async () => {
    await pay();
    // navigate("/places/what_is_manpukuji_temple");
    // navigate("/temple-map");
  };

  return (
    <div className={styles.clickToBuy}>
      <h2 className={styles.subtitle}>{interfaceText.buyScreen.clickToBuy}</h2>
      <h1 className={styles.title}>
        {interfaceText.buyScreen.templeExperience}
      </h1>
      <p className={styles.description}>
        <>{interfaceText.buyScreen.description1}</>
        <br />
        <>{interfaceText.buyScreen.description2}</>
        <br />
        <>{interfaceText.buyScreen.description3}</>
      </p>
      <MainButton onClick={handleBuy} size={"large"}>
        {interfaceText.buyScreen.buy}
      </MainButton>
    </div>
  );
};

export default ClickToBuy;
